import * as React from "react";

function CatEntertainment(props) {
  return (
    <svg
      id="prefix__Layer_2"
      data-name="Layer 2"
      width="2em"
      height="2em"
      viewBox="0 0 128 128"
      {...props}
    >
      <defs>
        <style>{".prefix__cls-2{stroke-width:0;fill:#1a1a1a}"}</style>
      </defs>
      <g id="prefix__Layer_1-2" data-name="Layer 1">
        <path
          className="prefix__cls-2"
          d="M86.743 52.124c-12.548 0-22.756-10.233-22.756-22.812S74.195 6.5 86.743 6.5 109.5 16.734 109.5 29.312 99.29 52.124 86.743 52.124zm0-40.624c-9.791 0-17.756 7.99-17.756 17.812s7.965 17.812 17.756 17.812 17.757-7.99 17.757-17.812S96.534 11.5 86.743 11.5z"
        />
        <path
          className="prefix__cls-2"
          d="M30.806 96.203a2.496 2.496 0 01-1.771-.734L20.75 87.16a2.5 2.5 0 01-.084-3.442l44.977-49.745 3.71 3.353-43.386 47.985 4.924 4.936 47.003-42.732 3.364 3.699-48.77 44.338c-.478.434-1.08.65-1.682.65z"
        />
        <path
          className="prefix__cls-2"
          transform="rotate(-44.922 62.462 54.356)"
          d="M59.962 45.534h5v17.642h-5z"
        />
        <path
          className="prefix__cls-2"
          d="M37.948 121.49c-4.45.001-8.839-1.455-12.358-4.42-4.317-3.635-6.827-8.728-7.07-14.341a19.898 19.898 0 015.769-14.88 2.501 2.501 0 013.541 3.531 14.884 14.884 0 00-4.315 11.132c.181 4.198 2.062 8.01 5.295 10.734 5.793 4.88 14.816 4.203 20.54-1.537l24.7-24.768A12.56 12.56 0 0183 83.224c3.384 0 6.563 1.32 8.954 3.717 4.932 4.945 4.932 12.99.001 17.935l-2.873 2.881a2.501 2.501 0 01-3.541-3.531l2.873-2.881c2.99-2.998 2.99-7.875 0-10.872-1.445-1.45-3.368-2.25-5.412-2.25s-3.966.8-5.411 2.249l-24.7 24.768c-4.125 4.135-9.578 6.25-14.943 6.25zM100.364 46.136c-14.538-3.946-26.306-14.78-31.478-28.98l4.697-1.712C78.2 28.12 88.702 37.79 101.675 41.311l-1.31 4.825z"
        />
        <path strokeWidth={0} fill="none" d="M0 0h128v128H0z" />
      </g>
    </svg>
  );
}

const MemoCatEntertainment = React.memo(CatEntertainment);
export default MemoCatEntertainment;
